export interface UserState {
  user_id: string;
  user_type: UserType;
  user_role: UserRole;
  team_id: string | null;
  first_name: string;
  last_name: string;
  email: string;
  created_at: string;
  use_intercom: boolean;
}

export const UserTypes = {
  Free: 'default',
  Premium: 'premium',
  Business: 'business',
  Education: 'education',
  Enterprise: 'enterprise',
  Admin: 'admin',
} as const;

export const UserRoles = {
  TEAM_OWNER: 'owner',
  TEAM_MEMBER: 'member',
  ENTERPRISE_ADMIN: 'admin',
  ENTERPRISE_GROUP_ADMIN: 'group_admin', // We don't use group_manager now, but we need to keep it for some users.
  ENTERPRISE_MEMBER: 'member',
  GUEST: 'guest',
  DEFAULT_ROLE: null,
};

export type UserType = typeof UserTypes[keyof typeof UserTypes];
export type UserRole = typeof UserRoles[keyof typeof UserRoles];
